import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClientDto, CreateClient, UpdateClient } from './clienti';

@Injectable({
  providedIn: 'root'
})
export class ClientiService {

  private url: string = environment.apiUrl + "/clients";


  constructor(private http: HttpClient) { }

  getAll(): Observable<ClientDto[]> {
    return this.http.get<ClientDto[]>(`${this.url}`);
  }

  create(data: CreateClient): Observable<ClientDto> {
    return this.http.post<ClientDto>(`${this.url}`, data);
  }

  read(id: string): Observable<ClientDto> {
    return this.http.get<ClientDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateClient): Observable<ClientDto> {
    return this.http.put<ClientDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

}

